import { Link } from 'react-router-dom';

const footerLinks = {
  Kategorien: [
    { label: 'Shoes', href: 'https://kaspreadsheet.com/category-911-Shoes.html' },
    { label: 'Hoodies/Sweaters', href: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
    { label: 'T-Shirts', href: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
    { label: 'Jackets', href: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  ],
  Mehr: [
    { label: 'Pants/Shorts', href: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
    { label: 'Headwear', href: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
    { label: 'Sets', href: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
    { label: 'Jersey', href: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  ],
  Einkaufsführer: [
    { label: 'OOPBuy Guide 2026', href: '/artikel/oopbuy-spreadsheet-guide-deutschland-2026', internal: true },
    { label: 'Sneaker Guide', href: '/artikel/oopbuy-sneaker-spreadsheet-guide', internal: true },
    { label: 'Sicherheit', href: '/artikel/oopbuy-sicher-bestellen-guide', internal: true },
    { label: 'Versand Guide', href: '/artikel/oopbuy-versand-deutschland-anleitung', internal: true },
    { label: 'Alle Guides', href: '/#ratgeber', internal: true },
  ],
  Rechtliches: [
    { label: 'Impressum', href: '#' },
    { label: 'Datenschutz', href: '#' },
    { label: 'Disclaimer', href: '#' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-[#0A2829] text-white">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div className="col-span-2 md:col-span-1 lg:col-span-2">
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="font-heading text-xl md:text-2xl font-semibold tracking-tight">
                OOPBuy<span className="text-primary-400">Spread</span>
              </span>
            </Link>
            <p className="text-sm text-white/60 leading-relaxed max-w-xs mb-6">
              Die größte deutschsprachige Plattform für OOPBuy Spreadsheet, Produktlisten, Guides und Einkaufshilfen.
            </p>
            <p className="text-xs text-white/40">
              Diese Website ist eine unabhängige Informationsplattform. Wir stehen nicht direkt mit OOPBuy in Verbindung.
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-white mb-4">{title}</h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    {link.internal ? (
                      <Link
                        to={link.href}
                        className="text-sm text-white/60 hover:text-white/90 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        target={link.href.startsWith('#') ? undefined : '_blank'}
                        rel={link.href.startsWith('#') ? undefined : 'noopener nofollow'}
                        className="text-sm text-white/60 hover:text-white/90 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} OOPBuySpread.de &mdash; Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 rounded-lg border border-white/20 flex items-center justify-center text-white/50 hover:text-white hover:border-white/40 transition-all cursor-pointer">
              <i className="ri-twitter-x-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 rounded-lg border border-white/20 flex items-center justify-center text-white/50 hover:text-white hover:border-white/40 transition-all cursor-pointer">
              <i className="ri-pinterest-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 rounded-lg border border-white/20 flex items-center justify-center text-white/50 hover:text-white hover:border-white/40 transition-all cursor-pointer">
              <i className="ri-reddit-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 rounded-lg border border-white/20 flex items-center justify-center text-white/50 hover:text-white hover:border-white/40 transition-all cursor-pointer">
              <i className="ri-youtube-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}